import { Container as ChakraContainer } from "@chakra-ui/react";

const Container = ({ small, children, ...props }) => (
  <ChakraContainer
    maxWidth={small ? "lg" : "xl"}
    px={small ? [3, 6, null, 8] : [6, null, null, 20]}
    pt={small ? [12, null, 28] : [16, null, 40]}
    pb={small ? [12, null, 28] : [12, null, 32]}
    {...props}
    title={null}
  >
    {children}
  </ChakraContainer>
);

export default Container;
